/* 
  ========================================================================
  Ejemplos de uso del DiscreteLoader en tus pantallas o modales:
  ========================================================================

    (Por defecto "Cargando..."):
      <DiscreteLoader />

    USO CON TEXTO:
      <DiscreteLoader text="Cargando datos de la sucursal..." />

    USO EN UN CONTENEDOR ESPECIFICO:
      <div className="h-[300px] relative">
        <DiscreteLoader text="Procesando pago..." className="bg-transparent" />
      </div>
*/
import React from 'react'
import { Spinner } from '@/app/lib/loader/loader'

interface DiscreteLoaderProps {
  /**
   * Texto que aparecerá debajo del spinner.
   * @default 'Cargando...'
   */
  text?: string

  className?: string
}

export function DiscreteLoader({
  text = 'Cargando...',
  className = ''
}: DiscreteLoaderProps) {
  return (
    <div className={`flex min-h-0 flex-1 flex-col items-center justify-center overflow-hidden bg-white p-6 ${className}`}>
      <Spinner className="h-8 w-8 animate-spin text-[#3B7D3B]" />
      {text && (
        <p className="mt-4 text-sm font-medium text-slate-500 animate-pulse">
          {text}
        </p>
      )}
    </div>
  )
}
